import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  RACModal,
  RACButton,
  makeStyles,
  RACToggle,
  Box,
  Typography,
} from '@rentacenter/racstrap';

import { ReactComponent as CameraIcon } from '../../assets/img/camera.svg';
import { isTablet } from 'react-device-detect';

export const useStyles = makeStyles((theme: any) => ({
  dialogContent: {
    textAlign: 'center',
    margin: `2rem 0 1rem`,
    height: '20%',
    overflow: 'visible',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(16),
  },
  dialogActions: {
    justifyContent: 'flex-end',
    position: 'sticky',
    bottom: 0,
  },

  barcodeClass: {
    padding: '0px',
    margin: '0px',
    marginTop: '0px',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'space-between',
    marginTop: theme.typography.pxToRem(8),
  },
  group: {
    display: 'flex',
    gap: 8,
    maxHeight: theme.typography.pxToRem(50),
  },
  dialogRoot: {
    height: '100%',
    '& .MuiPaper-rounded': {
      borderRadius: theme.typography.pxToRem(12),
    },
    '& .MuiDialog-paperScrollPaper': {
      width: '43%',
      minHeight: theme.typography.pxToRem(230),
      minWidth: theme.typography.pxToRem(300),
    },
    '& .MuiDialogTitle-root': {
      display: 'none',
    },
    '& .MuiTypography-h5': {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: 500,
      lineHeight: theme.typography.pxToRem(30),
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'center',
    },
  },
  contentHeight: {
    height: '30%',
    overflow: 'scroll',
  },
  confirmSpan: {
    marginTop: '0.75rem',
  },
}));
export interface CameraDetectConfirmModalProps {
  message: string;
  onResolve: (type: string) => void;
  onClose: () => void;
}

export const CameraDetectConfirmModal = ({
  message,
  onResolve,
  onClose,
}: CameraDetectConfirmModalProps) => {
  const classes = useStyles();
  const history = useHistory();
  const [enableCamera, setEnableCamera] = useState(false);
  const [cameraAllowed, setCameraAllowed] = useState(true);
  const [jumpToCameraPopup, setJumpToCameraPopup] = useState(false);
  const [facingMode, setFacingMode] = useState<'user' | 'environment'>(
    isTablet ? 'environment' : 'user'
  );

  const lookForCamera = async (): Promise<boolean> => {
    if (!navigator.mediaDevices?.enumerateDevices) {
      return false;
    }

    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoInputs = devices.filter((d) => d.kind === 'videoinput');

    return videoInputs.length > 0;
  };

  useEffect(() => {
    if (jumpToCameraPopup) {
      setTimeout(() => {
        // Pass facingMode to onResolve
        onResolve(facingMode);
      }, 200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jumpToCameraPopup, facingMode]);

  useEffect(() => {
    // check here
    const performCameraChecks = async () => {
      const cameraPresent = await lookForCamera();

      setCameraAllowed(cameraPresent && isTablet);
    };

    performCameraChecks();
  }, []);

  return (
    <RACModal
      isOpen
      classes={{
        dialogContent: classes.dialogContent,
        dialog: classes.dialogRoot,
      }}
      maxWidth="lg"
      title={''}
      content={
        <>
          <span></span>
          <span className={classes.confirmSpan}>{message}</span>
          <span className={classes.confirmSpan}>
            Would you like to enable the camera to capture the receipt?
          </span>
        </>
      }
      onClose={onClose}
      buttons={
        <>
          <div className={classes.group}>
            <div className={classes.column}>
              <span
                style={{
                  padding: '0px',
                  paddingLeft: '30px',
                  marginTop: '0px',
                  position: 'relative',
                  top: '-40px',
                }}
              >
                <Typography
                  variant="body1"
                  style={{ padding: '0px', marginTop: '0px' }}
                >
                  <CameraIcon className={classes.barcodeClass} />
                  <span
                    style={{
                      paddingLeft: '10px',
                      marginTop: '0px',
                      position: 'relative',
                      top: '-10px',
                    }}
                  >
                    Enable Camera
                  </span>
                  <RACButton
                    style={{
                      marginLeft: '70px',
                      position: 'relative',
                    }}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      history.push('/mpo/pos');
                    }}
                  >
                    Skip
                  </RACButton>
                </Typography>

                <Box ml={10}>
                  <RACToggle
                    toggleColor="blue"
                    style={{
                      padding: '0px',
                      marginTop: '0px',
                    }}
                    disabled={!cameraAllowed}
                    checked={enableCamera}
                    OnClick={() => {
                      setEnableCamera(!enableCamera);
                      // Toggle facingMode between 'user' and 'environment'
                      setFacingMode(
                        facingMode === 'environment' ? 'user' : 'environment'
                      );
                      setJumpToCameraPopup(true);
                    }}
                  />
                </Box>
              </span>
            </div>
          </div>
        </>
      }
    />
  );
};
